import { Link } from 'react-router-dom'
import { ModalShell } from '../../admin/modals/ModalShell'
import { useManagerClientsByCategory } from './useDrilldown'

function formatRub(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `₽ ${(n / 1_000_000).toFixed(1)}M`
  if (Math.abs(n) >= 1_000) return `₽ ${Math.round(n / 1_000)}K`
  return `₽ ${Math.round(n)}`
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  })
}

const CATEGORY_LABEL: Record<'A' | 'B' | 'C', string> = {
  A: 'Ключевые заказчики (A)',
  B: 'Растущие клиенты (B)',
  C: 'Новые заказчики (C)',
}

export function ClientCategoryModal({
  category,
  onClose,
}: {
  category: 'A' | 'B' | 'C'
  onClose: () => void
}) {
  const { data, isLoading, isError } = useManagerClientsByCategory(category)

  return (
    <ModalShell
      title={CATEGORY_LABEL[category]}
      subtitle="Мои клиенты в этой категории · топ по сумме КП"
      onClose={onClose}
      size="lg"
    >
      {isLoading && <p className="text-sm text-gray-400">Загрузка…</p>}
      {isError && <p className="text-sm text-red-600">Не удалось загрузить клиентов</p>}
      {data && (
        <div className="space-y-4">
          <div className="flex justify-end">
            <Link
              to={`/clients?category=${category}`}
              onClick={onClose}
              className="text-sm text-brand-600 hover:underline"
            >
              Все клиенты категории {category} →
            </Link>
          </div>

          {data.clients.length === 0 ? (
            <p className="text-sm text-gray-400 py-4 text-center">
              У вас нет клиентов категории {category}
            </p>
          ) : (
            <div className="divide-y divide-gray-100 rounded-xl border border-gray-100">
              {data.clients.map((c) => (
                <Link
                  key={c.id}
                  to={`/clients/${c.id}`}
                  onClick={onClose}
                  className="flex items-center gap-3 px-3 py-2 text-sm hover:bg-gray-50"
                >
                  <span className="flex-1 min-w-0">
                    <span className="block text-gray-900 truncate">{c.name}</span>
                    {c.city && <span className="block text-xs text-gray-400">{c.city}</span>}
                  </span>
                  <span className="text-xs text-gray-500 tabular-nums w-20 text-right">
                    {c.requestsCount} заявок
                  </span>
                  <span className="text-xs text-gray-500 tabular-nums w-24 text-right">
                    {c.lastRequestAt ? formatDate(c.lastRequestAt) : '—'}
                  </span>
                  <span className="text-sm font-semibold text-gray-900 tabular-nums w-24 text-right">
                    {formatRub(c.kpSumRub)}
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      )}
    </ModalShell>
  )
}
